import styled from 'styled-components';
import colors from 'utils/colors';

export const Container = styled.div`
  border: 2pt solid ${colors.brandingPrimary};
  border-radius: 5px;
  flex-basis: ${props => props.flexBasis || '25%'};
  flex-grow: 1;
  margin: 1rem;
  align-self: baseline;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 3px;

  tr:first-child th {
    border-bottom: 2pt solid ${colors.brandingPrimary};
  }
`;

export const ViewWrapper = styled.div`
  display: flex;
  padding: 1rem;
  justify-content: center;
  border: none;
  font-weight: 400;
`;

export const TableRow = styled.tr`
  background: ${props => props.background || '#fff'};

  td {
    border-bottom: 2pt solid ${colors.brandingPrimary};
  }
  &:last-child {
    border-bottom: none;
  }
`;

export const TableData = styled.td`
  font-weight: 400;
  padding: 1rem;
  border-bottom: ${props => props.border || 'inherit'};
`;

export const TableHeader = styled.th`
  text-align: left;
  color: ${colors.gray};
  margin-bottom: 0.5rem;
  font-weight: 400;
  padding: 1rem;
  border-bottom: 2pt solid ${colors.brandingPrimary};
`;

export const Heading = styled.div`
  border-bottom: 2pt solid ${colors.brandingPrimary};
  border-radius: 3px 3px 0px 0px;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 700;
  background-color: #fff;

  svg {
    margin-right: 1rem;
  }
`;

export const H2Dashboard = styled.div`
  margin-top: 1rem;
  padding-left: 1rem;
  font-weight: 700;
  font-size: 1.3125rem;
`;

export const StatContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;

  @media screen and (max-width: 1500px) {
    flex-wrap: wrap;
  }
`;

export const BlueSection = styled.div`
  padding: 2rem;
  padding-bottom: 3rem;
  color: #fff;
  background-color: ${colors.brandingPrimary};
`;

export const DashboardContent = styled.div`
  margin-top: -5.5rem;
  padding: 2rem;
  justify-content: center;
`;
